import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
// import { FaDownload, FaPen } from "react-icons/fa";

const PrivacyPolicy = () => {
  return (
    <main id="main-content" className="flex-1 bg-light p-4">
      <Container fluid id="privacy-policy-module">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="h3 fw-bold text-dark">Privacy Policy</h2>
            <p className="text-muted">
              Data protection and privacy compliance information
            </p>
          </div>
          {/* <div className="d-flex gap-2">
            <Button variant="secondary" className="d-flex align-items-center">
              <FaDownload className="me-2" /> Download PDF
            </Button>
            <Button variant="dark" className="d-flex align-items-center">
              <FaPen className="me-2" /> Edit Policy
            </Button>
          </div> */}
        </div>

        {/* Metadata */}
        <Card className="p-4 mb-4 shadow-sm">
          <Row>
            <Col md={3} className="text-center">
              <div className="text-muted small">Last Updated</div>
              <div className="fw-semibold">October 19, 2025</div>
            </Col>
            <Col md={3} className="text-center">
              <div className="text-muted small">Version</div>
              <div className="fw-semibold">1.0</div>
            </Col>
            <Col md={3} className="text-center">
              <div className="text-muted small">Effective Date</div>
              <div className="fw-semibold">December 31, 2025</div>
            </Col>
            <Col md={3} className="text-center">
              <div className="text-muted small">Language</div>
              <div className="fw-semibold">English (EN)</div>
            </Col>
          </Row>
        </Card>

        {/* Table of Contents */}
        <Card className="p-4 mb-4 shadow-sm">
          <h5 className="fw-semibold mb-3">Table of Contents</h5>
          <Row>
            <Col md={6}>
              <ul className="list-unstyled">
                <li>
                  <a href="#introduction">Introduction</a>
                </li>
                <li>
                  <a href="#who-we-are">1. Who We Are</a>
                </li>
                <li>
                  <a href="#scope">2. Scope of This Policy</a>
                </li>
                <li>
                  <a href="#information">3. Information We Collect</a>
                </li>
                <li>
                  <a href="#legal-basis">4. Legal Basis for Processing</a>
                </li>
                <li>
                  <a href="#usage">5. How We Use Your Data</a>
                </li>
                <li>
                  <a href="#sharing">6. Data Sharing and Disclosure</a>
                </li>
                <li>
                  <a href="#storage">7. Data Storage and Security</a>
                </li>
              </ul>
            </Col>
            <Col md={6}>
              <ul className="list-unstyled">
                <li>
                  <a href="#retention">8. Data Retention</a>
                </li>
                <li>
                  <a href="#gdpr-rights">9. Your GDPR Rights</a>
                </li>
                <li>
                  <a href="#cookies">10. Cookies and Tracking</a>
                </li>
                <li>
                  <a href="#transfers">11. International Data Transfers</a>
                </li>
                <li>
                  <a href="#children">12. Children’s Privacy</a>
                </li>
                <li>
                  <a href="#changes">13. Changes to This Policy</a>
                </li>
                <li>
                  <a href="#contact">14. Contact Us</a>
                </li>
              </ul>
            </Col>
          </Row>
        </Card>

        {/* Sections */}
        <div id="policy-content">
          <Card id="introduction" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">Introduction</h5>
            <p>
              GrantNest (“we”, “our”, “us”) is a project coordination and
              management platform developed by ABARKA ONGD and created by
              Clotaire Ntienou. We are committed to protecting your personal
              data and respecting your privacy in compliance with the General
              Data Protection Regulation (GDPR) and applicable data protection
              laws. This Privacy Policy explains how we collect, use, store, and
              protect your information when you use GrantNest.
            </p>
          </Card>
          {/* 1. Who We Are */}
          <Card id="who-we-are" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">1. Who We Are</h5>
            <ul>
              <li>
                <strong>Data Controller:</strong> ABARKA ONGD
              </li>
              <li>
                <strong>Product:</strong> GrantNest
              </li>
              <li>
                <strong>Product Owner:</strong> ABARKA ONGD
              </li>
              <li>
                <strong>Creator:</strong> Clotaire Ntienou
              </li>
              <li>
                <strong>Email:</strong> info@ongabarka.org
              </li>
              <li>
                <strong>Address:</strong> Agerrealde Etxadia 7bajo, 20180,
                Oiartzun, Guipúzcoa, Spain
              </li>
            </ul>
          </Card>

          {/* 2. Scope */}
          <Card id="scope" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">2. Scope of This Policy</h5>
            <p>
              This Privacy Policy applies to all users of GrantNest, including:
            </p>
            <ul>
              <li>Project Coordinators (Admins)</li>
              <li>Assistants</li>
              <li>Partner Organizations</li>
              <li>Team Members</li>
              <li>External Viewers / Auditors</li>
            </ul>
          </Card>

          {/* 3. Information We Collect */}
          <Card id="information" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">3. Information We Collect</h5>
            <p>
              GrantNest collects and processes the following categories of
              information:
            </p>
            <ul>
              <li>
                <strong>User Account Data:</strong> Name, email, organization,
                role, credentials.
              </li>
              <li>
                <strong>Project & Partner Data:</strong> Titles, deadlines,
                reports, partner info.
              </li>
              <li>
                <strong>Financial Information:</strong> Budgets, expenditure,
                receipts.
              </li>
              <li>
                <strong>Uploaded Documents:</strong> Reports, contracts,
                annexes.
              </li>
              <li>
                <strong>Technical & Usage Data:</strong> IP, browser type,
                device logs.
              </li>
            </ul>
          </Card>

          {/* 4. Legal Basis */}
          <Card id="legal-basis" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">4. Legal Basis for Processing</h5>
            <ul>
              <li>Contractual necessity</li>
              <li>Legal obligations</li>
              <li>Legitimate interests</li>
              <li>Consent (optional services)</li>
            </ul>
          </Card>

          {/* 5. How We Use Your Data */}
          <Card id="usage" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">5. How We Use Your Data</h5>
            <ul>
              <li>Manage projects, partners, and budgets</li>
              <li>Facilitate document uploads</li>
              <li>Generate reports</li>
              <li>Provide notifications</li>
              <li>Ensure compliance</li>
            </ul>
          </Card>

          {/* 6. Data Sharing */}
          <Card id="sharing" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">6. Data Sharing and Disclosure</h5>
            <p>
              We may share with project partners, funding bodies, auditors, IT
              providers. Never sold.
            </p>
          </Card>

          {/* 7. Storage */}
          <Card id="storage" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">7. Data Storage and Security</h5>
            <p>
              We use EU servers, encryption, access control, daily backups, and
              monitoring.
            </p>
          </Card>

          {/* 8. Retention */}
          <Card id="retention" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">8. Data Retention</h5>
            <p>
              Data retained as required for projects, audits, legal
              requirements. Archived securely.
            </p>
          </Card>

          {/* 9. GDPR Rights */}
          <Card id="gdpr-rights" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">9. Your GDPR Rights</h5>
            <ul>
              <li>Access, Rectify, Delete</li>
              <li>Restrict, Portability</li>
              <li>Object, Withdraw consent</li>
            </ul>
          </Card>

          {/* 10. Cookies */}
          <Card id="cookies" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">10. Cookies and Tracking</h5>
            <p>
              GrantNest uses cookies for logins, usability, analytics. Can
              disable in browser.
            </p>
          </Card>

          {/* 11. Transfers */}
          <Card id="transfers" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">
              11. International Data Transfers
            </h5>
            <p>
              No transfers outside EEA unless adequate safeguards are applied.
            </p>
          </Card>

          {/* 12. Children */}
          <Card id="children" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">12. Children’s Privacy</h5>
            <p>No data knowingly collected from under 16 without consent.</p>
          </Card>

          {/* 13. Changes */}
          <Card id="changes" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">13. Changes to This Policy</h5>
            <p>We may update. Users notified of major updates.</p>
          </Card>

          {/* 14. Contact */}
          <Card id="contact" className="p-4 mb-4 shadow-sm">
            <h5 className="fw-semibold mb-3">14. Contact Us</h5>
            <p>
              ABARKA ONGD <br />
              📧 info@ongabarka.org <br />
              🏢 Agerrealde Etxadia 7bajo, 20180, Oiartzun, Guipúzcoa, Spain
            </p>
          </Card>
        </div>
      </Container>
    </main>
  );
};

export default PrivacyPolicy;
